import { render, staticRenderFns } from "./JccxRecord.vue?vue&type=template&id=95c15904&scoped=true&"
import script from "./JccxRecord.vue?vue&type=script&lang=js&"
export * from "./JccxRecord.vue?vue&type=script&lang=js&"
import style0 from "./JccxRecord.vue?vue&type=style&index=0&id=95c15904&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c15904",
  null
  
)

export default component.exports